import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tick",
  "use": "icon-tick-usage",
  "viewBox": "0 0 26.85 21.33",
  "content": "<symbol viewBox=\"0 0 26.85 21.33\" id=\"icon-tick\">\r\n    <path d=\"M7.76,21.85,1.13,15.21a1,1,0,0,1,1.41-1.41L7.76,19,26,.81a1,1,0,0,1,1.41,1.41Z\" transform=\"translate(-0.83 -0.51)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/tick.svg
// module id = ddC+
// module chunks = 0